import React from "react";
import HeroImage from "../assets/raj1.jpg";
import resumePdf from "../assets/resume.pdf";
import { FaGithub, FaLinkedin } from "react-icons/fa";
import { HiOutlineMail } from "react-icons/hi";
import {
  MdOutlineFileDownload,
  MdOutlineKeyboardArrowRight,
} from "react-icons/md";
import { Link } from "react-scroll";

const Home = () => {
  const metrics = [
    {
      value: "3+ years",
      label: "Software engineering",
      detail: "HRMS, CRM, SaaS, and product workflows.",
    },
    {
      value: "Frontend + APIs",
      label: "Product application scope",
      detail: "User interfaces, BFF layers, Supabase, and webhooks.",
    },
    {
      value: "Live products",
      label: "Delivery and ownership",
      detail: "CMS, analytics, automation, and business workflows.",
    },
  ];

  const focusAreas = [
    "Product workflows",
    "API integrations",
    "Automation systems",
  ];

  return (
    <section
      name="home"
      className="min-h-screen overflow-hidden bg-[#080b0d] px-5 pt-28 pb-20 text-white lg:px-8 lg:pt-32"
    >
      <div className="mx-auto grid w-full max-w-7xl min-w-0 items-center gap-12 lg:grid-cols-[0.95fr_0.85fr]">
        <div className="min-w-0">
          <div className="mb-6 flex flex-wrap items-center gap-3">
            <span className="rounded-full border border-emerald-400/30 bg-emerald-400/10 px-4 py-2 text-xs font-extrabold uppercase tracking-[0.16em] text-emerald-200">
              Raj - Frontend-heavy Software Engineer
            </span>
            <span className="rounded-full border border-white/10 bg-white/5 px-4 py-2 text-xs font-bold uppercase tracking-[0.16em] text-zinc-300">
              Product, APIs, and automation
            </span>
          </div>

          <h1 className="max-w-full text-4xl font-extrabold leading-tight text-white sm:max-w-4xl sm:text-6xl">
            Building production software across user interfaces, APIs, and
            product workflows.
          </h1>

          <p className="mt-6 max-w-2xl text-lg leading-8 text-zinc-300 sm:text-xl">
            I build React, Next.js, and TypeScript applications, with hands-on
            work across API integrations, backend-connected workflows, CMS,
            analytics, webhooks, and automation.
          </p>

          <div className="mt-8 flex flex-col items-stretch gap-3 sm:flex-row sm:items-center">
            <a
              href={resumePdf}
              download="Raj Resume.pdf"
              className="inline-flex w-full items-center justify-center gap-2 rounded-md bg-emerald-400 px-6 py-3 text-base font-extrabold text-[#080b0d] transition hover:bg-emerald-300 sm:w-auto"
            >
              <MdOutlineFileDownload size={22} />
              Download Resume
            </a>
            <Link
              to="experience"
              smooth
              duration={500}
              offset={-72}
              className="inline-flex w-full cursor-pointer items-center justify-center gap-2 rounded-md border border-white/15 bg-white/5 px-6 py-3 text-base font-extrabold text-white transition hover:border-emerald-300 hover:text-emerald-200 sm:w-auto"
            >
              View Experience
              <MdOutlineKeyboardArrowRight size={22} />
            </Link>
          </div>

          <div className="mt-7 flex flex-wrap items-center gap-3">
            <a
              href="mailto:rpal778866@gmail.com"
              className="inline-flex h-11 w-11 items-center justify-center rounded-full border border-white/10 bg-white/[0.04] text-zinc-300 transition hover:border-emerald-300 hover:text-emerald-200"
              aria-label="Email Raj"
            >
              <HiOutlineMail size={20} />
            </a>
            <a
              href="https://www.linkedin.com/in/raj-pal-a052211b5/"
              target="_blank"
              rel="noreferrer"
              className="inline-flex h-11 w-11 items-center justify-center rounded-full border border-white/10 bg-white/[0.04] text-zinc-300 transition hover:border-emerald-300 hover:text-emerald-200"
              aria-label="Raj on LinkedIn"
            >
              <FaLinkedin size={19} />
            </a>
            <a
              href="https://github.com/Raj-Stark"
              target="_blank"
              rel="noreferrer"
              className="inline-flex h-11 w-11 items-center justify-center rounded-full border border-white/10 bg-white/[0.04] text-zinc-300 transition hover:border-emerald-300 hover:text-emerald-200"
              aria-label="Raj on GitHub"
            >
              <FaGithub size={19} />
            </a>
          </div>

          <div className="mt-9 grid gap-3 border-t border-white/10 pt-6 sm:grid-cols-3">
            {metrics.map(({ value, label, detail }) => (
              <div
                key={value}
                className="rounded-md border border-white/10 bg-white/[0.035] p-4"
              >
                <p className="text-base font-extrabold text-emerald-300">
                  {value}
                </p>
                <p className="mt-2 text-sm font-bold leading-5 text-zinc-200">
                  {label}
                </p>
                <p className="mt-2 text-xs font-semibold leading-5 text-zinc-500">
                  {detail}
                </p>
              </div>
            ))}
          </div>
        </div>

        <div className="min-w-0">
          <div className="mx-auto max-w-[310px] sm:max-w-[350px] lg:ml-auto lg:mr-0 lg:max-w-[390px]">
            <div className="relative aspect-square overflow-hidden rounded-md border border-white/10 bg-[#111719] shadow-2xl shadow-black/30">
              <img
                src={HeroImage}
                alt="Raj"
                className="h-full w-full object-cover object-center grayscale-[8%]"
              />
              <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-[#080b0d] via-[#080b0d]/75 to-transparent p-4 pt-20 sm:p-5 sm:pt-24">
                <p className="text-xs font-extrabold uppercase tracking-[0.18em] text-emerald-300">
                  Noida, Uttar Pradesh, India
                </p>
                <h2 className="mt-2 text-3xl font-extrabold text-white">Raj</h2>
              </div>
            </div>

            <div className="mt-5 hidden flex-wrap gap-2 sm:flex">
              {focusAreas.map((area) => (
                <span
                  key={area}
                  className="rounded-full border border-white/10 bg-white/[0.04] px-3 py-2 text-sm font-bold text-zinc-300"
                >
                  {area}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Home;
